<template>
  <AsyncData :request-state="requestState">
    <v-data-table
      :headers="headers"
      :items="response.items"
      :total-items="response.total"
      item-key="caseId"
      :pagination.sync="proxyPagination"
      :rows-per-page-items="[2, 10, 25, 50, 100]"
      rowsPerPage>
      <template slot="items" slot-scope="props">
        <invoice-list-item :item="props.item"/>
      </template>
    </v-data-table>
  </AsyncData>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import _ from 'lodash'
  import AsyncData from "../../Ui/AsyncData";
  import DateWithMinutes from '../../Filters/DateWithMinutes'
  import NoEmpty from '../../Filters/NoEmpty'
  import InvoiceListItem from "./InvoiceListItem";

  export default {
    name: 'invoices-list',
    components: {
      AsyncData,
      InvoiceListItem
    },
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    data() {
      return {
        headers: [
          {
            text: 'Id',
            align: 'left',
            sortable: false,
            value: 'id',
            width: '50px'
          },
          {
            text: 'Client',
            align: 'left',
            sortable: false,
            value: 'client',
            width: '100px'
          },
          {
            text: 'From',
            align: 'left',
            sortable: false,
            value: 'from',
            width: '100px'
          },
          {
            text: 'To',
            align: 'left',
            sortable: false,
            value: 'to',
            width: '100px'
          },
          {
            text: 'Cases count',
            align: 'left',
            sortable: false,
            width: '100px'
          },
          {
            text: 'Sum',
            align: 'left',
            sortable: false,
            width: '100px'
          },
          {
            text: 'Status',
            align: 'left',
            sortable: false,
            value: 'status',
            width: '100px'
          },
          {
            text: 'Actions',
            align: 'left',
            sortable: false,
            value: 'status',
            width: '100px'
          },
        ],
      }
    },
    mounted() {
      this.invoicesFetchFiltered()
    },
    computed: {
      ...mapState({
        pagination: state => state.invoices.filter.pagination,
        response: state => state.invoices.response,
        requestState: state => state.invoices.requestState
      }),
      proxyPagination: {
        get() {
          return {
            page: this.pagination.page,
            rowsPerPage: this.pagination.rowsPerPage
          };
        },
        set(newValue) {
          let newPagination = {
            page: newValue.page,
            rowsPerPage: newValue.rowsPerPage
          };

          if (_.isEqual(this.proxyPagination, newPagination)) {
            return
          }

          this.invoicesChangeFilter({
            pagination: newPagination
          })
        },
      }
    },
    methods: {
      ...mapActions({
        invoicesChangeFilter: 'invoicesChangeFilter',
        invoicesFetchFiltered: 'invoicesFetchFiltered',
      })
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/InvoicesList.vue